<template>
    <div v-show="registrars.length > 1">
        <!--<p>Multiple Registrars not yet implemented</p>-->
    </div>
</template>
<script>
    export default {
        data: function() {
            return {
                selected: false,
                registrars: window.registrar_list,
                model: {}
            };
        },
        watch: {
            selected() {
                this.$emit('input', this.selected);
            }
        },
        created() {
            this.$nextTick(function () { // Runs after content is updated
                $.each(this.registrars, (key, val) => {
                    if (typeof val['registrar'] === 'undefined') {
                        fyi('Error finding any registrars');
                        return;
                    }
                    if (val['registrar'] === "aussiehq") {
                        return;
                    }
                    this.$emit('input', val['public_id']);
                    return false;
                });
            });
            //this.$emit('input', this.model);
//            this.$eventHub.$on('setWhois', this.setWhois);
        },
        methods: {},
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
//                this.$eventHub.$off('setWhois', this.setWhois);
        }
    }
</script>
